// import 'video.js/dist/video-js.min.css';
import videojs from 'video.js';
// import 'videojs-vimeo-tech';
import './Vimeo.js';

class VideoImageFullscreen {

  constructor() {

    this.debug = window.location.search == "?debug" ? true : false;
    // this.debug = true;
    this.videojs = videojs;
    // this.pauseWhenOutOfView = false;
    this.hasSectionCtaVideoImageCover = false;
    this.windowHasLoaded = false;
    this.players = [];
    this.observer = null;
    window.VideoImageFullscreen = this;

    if(this.debug) console.log('VideoImageFullscreen this.observer', this.observer);

  }

  init() {

    let _self = this;

    let videoBlocks = $('div[data-barba="container"]:last .o-video-image-fullscreen');
    let videoElements = videoBlocks.find('video');
    this.videoBlocks = videoBlocks;

    if(_self.debug) console.log('VideoImageFullscreen INIT videoElements', this.videoBlocks);

    if(this.videoBlocks.length > 0) {

      const videoJsOptions = {
        autoplay: true,
        loop: true,
        controls: false,
        responsive: true,
        fluid: true,
        muted: true,
        vimeo: {
          pip: false,
          background: true,
          maxheight: 1234,
          autopause: false,
        }
        // aspectRatio: '335:172', // 1.95:1
        // sources: [{
        //   src: '/path/to/video.mp4',
        //   type: 'video/mp4'
        // }]
      };

      // init observer
      _self.initObserver();

      // this.videoElements.each(function(i,videoElement){
      this.videoBlocks.each(function(i,videoBlock){


        if(_self.debug) console.log('VideoImageFullscreen videoBlock', videoBlock);

        // if ($(videoBlock).is(':visible') ) {
        if (videoBlock.offsetParent) {

          let videoElement = $(videoBlock).find('video').get(0);
          if(_self.debug) console.log('VideoImageFullscreen videoElement', videoElement);
          if(videoElement) {

            $(videoElement).attr('data-setup', $(videoElement).attr('data-setup-videojs'));
            //init videojs player
            var player = videojs(videoElement, videoJsOptions, () => {
              if(_self.debug) videojs.log('player is ready', this);
              // onReady && onReady(player);

              player.on('error', function(err){
                if(_self.debug) console.log('error: ',err, player.tech_.errorName);
                if((player.tech_.errorName == 'PlayInterrupted' || player.tech_.errorName == 'AbortError') && player.tech_.errorMethod == 'play') {
                  if(_self.debug) console.log('VideoImageFullscreen '+player.tech_.errorName+' play', player);
                  
                  player.tech_.vimeoPlayer.setMuted(true).then(function(){
                    player.tech_.vimeoPlayer.getPaused().then(function(paused){
                      if(paused) {
                        player.error(null);
                        if(_self.debug) console.log('VideoImageFullscreen '+player.tech_.errorName+' play new attempt', player);
                        player.play();
                      }
                    });
                  });
                }
              });

            });
            // player.src({src: $(videoElement).attr('data-setup-src')});

            _self.players.push(player);

            player.on('ready', function(e){

              if(_self.debug) console.log('VideoImageFullscreen player video ready', e, this, videoBlock, this.muted());
              $(e.target).closest('.o-video-image-fullscreen').addClass('is-ready');
            });
            player.one('play', function(e){

              // if(_self.pauseWhenOutOfView) {
              //   // pause on first play to enable play/pause when scrolling into/out of view
              //   let _player = player;

              //   setTimeout(function () {
              //     if(_self.debug) console.log('VideoImageFullscreen pause?', _player);
              //     _player.pause();
              //   }, 50);
              // }
              if(_self.debug) console.log('VideoImageFullscreen player video play', e, this, videoBlock, this.muted());
              this.muted(true);
              $(e.target).closest('.o-video-image-fullscreen').addClass('has-started');

            });


            // if(_self.pauseWhenOutOfView) {
            //   var videoPlayerScrollTrigger = ScrollTrigger.create({
            //     id: 'videoPlayerScrollTrigger-'+i,
            //     trigger: videoBlock,
            //     start: "top bottom",
            //     end: "bottom top",
            //     onToggle: self => {
            //       if(_self.debug) console.log("toggled, videoPlayerScrollTrigger-"+i+" isActive:", self.isActive);
            //         //is it in view ?
            //         if (self.isActive) {
            //           if(_self.debug) console.log('VideoImageFullscreen scrollTrigger isActive video PLAY');
            //           player.play();
            //         } else {
            //           if(_self.debug) console.log('VideoImageFullscreen scrollTrigger isActive video PAUSE');
            //           player.pause();
            //         }

            //     },
            //     markers: _self.debug,
            //   });
            // }

          }


          let videoContainer = $(videoBlock).closest('.o-section-cta-video-image-cover__main-content');
          if (videoContainer.length) {
            // if(_self.windowHasLoaded) _self.videoBgEnlarge(videoContainer);
            if(_self.windowHasLoaded) _self.videoBgObserve(videoContainer);
            if(this.hasSectionCtaVideoImageCover == false) {
              this.hasSectionCtaVideoImageCover = true; //add resize event only once
            }
          }

        } else {
          if(_self.debug) console.log('VideoImageFullscreen videoBlock is not visible', videoBlock);
        }

      });

      $(window).on('resize', _.debounce(this._resize.bind(this), 400));

      if($('html').hasClass('loading')) {

        $(window).one('load', function(){
          _self.windowHasLoaded = true;
          _self._resize();
        });

      } else {

        setTimeout(function(){
          _self.windowHasLoaded = true;
          _self._resize();
        },400);

      }

    }

  }

  initObserver(){

    let _self = this;

    // first unobserve if already created
    if(_self.observer != null) {
      _self.videoBgUnobserve();
      _self.observer.disconnect();
      _self.observer = null;
    }

    // new `IntersectionObserver` constructor
    _self.observer = new IntersectionObserver((entries) => {
      // Loop through all `entries` returned by the observer
      for (const entry of entries) {
        // The `entry.boundingClientRect` is where all the dimensions are stored
        const bounds = entry.boundingClientRect;
        // Log the `bounds` for every element
        if(_self.debug) console.log('videoImageFullscreen observer', entry, bounds);
        entry.target.dataset.boundsWidth = `${bounds.width}`;
        entry.target.dataset.boundsHeight = `${bounds.height}`;
        // Then do whatever with `bounds`
      }
      
      if(_self.debug) console.log('videoImageFullscreen observer disconnected', entries);
      if(entries.length > 0 && typeof entries[1].target != 'undefined') _self.videoBgEnlarge(entries[1].target);
      // Disconnect the observer to stop from running in the background
      _self.observer.disconnect();
    });
    if(_self.debug) console.log('videoImageFullscreen observer ?', _self.observer);

  }

  _resize() {

    let _self = this;

    if(this.debug) console.log('VideoImageFullscreen _resize this?', this);

    this.videoBlocks.each(function(i,videoBlock){
      // check this videoElement is in a section-cta-video-image-cover and it is visible
      let videoContainer = $(videoBlock).closest('.o-section-cta-video-image-cover__main-content');
      if(this.debug) console.log('VideoImageFullscreen _resize videoContainer?', videoContainer);
      if (videoContainer.length && $(videoBlock).is(':visible') ) {
        // if(_self.windowHasLoaded) _self.videoBgEnlarge(videoContainer);
        if(_self.windowHasLoaded) _self.videoBgObserve(videoContainer);
      }
    });

  }

  videoBgObserve(videoContainer) {
    if(this.debug) console.log('videoBgObserve resize videoContainer', videoContainer);
    let $videoBgAspect = videoContainer.find('.o-video-image-fullscreen:visible .vjs-tech');
    // Run the `observe` function of the `IntersectionObserver` on the elements
    if($videoBgAspect.length) this.observer.observe($videoBgAspect.get(0));
    this.observer.observe(videoContainer.get(0));
  }
  
  videoBgUnobserve(videoContainer) {
    if(this.debug) console.log('videoBgUnobserve resize videoContainer', videoContainer);
    let $videoBgAspect = videoContainer.find('.o-video-image-fullscreen:visible .vjs-tech');
    // Run the `observe` function of the `IntersectionObserver` on the elements
    if($videoBgAspect.length) this.observer.unobserve($videoBgAspect.get(0));
    this.observer.unobserve(videoContainer.get(0));
  }

  videoBgEnlarge(videoContainer) {

    if(this.debug) console.log('videoBgEnlarge resize videoContainer', videoContainer);
    let theVideoContainer = $(videoContainer);
    let $videoBgAspect = theVideoContainer.find('.o-video-image-fullscreen:visible .vjs-tech');
    if($videoBgAspect.length) {

      let $videoBgWidth = theVideoContainer.find('.o-video-image-fullscreen:visible .video-js.vjs-fluid');
      let videoAspect = $videoBgAspect.get(0).dataset.boundsHeight / $videoBgAspect.get(0).dataset.boundsWidth;
      let windowAspect = videoContainer.dataset.boundsHeight / videoContainer.dataset.boundsWidth;
      // if(this.debug) console.log('videoBgEnlarge resize videoAspect', videoAspect, 'windowAspect', windowAspect, '$videoBgAspect.outerHeight()', $videoBgAspect.outerHeight(), '$videoBgAspect.outerWidth()', $videoBgAspect.outerWidth(), 'videoContainer.outerHeight()', videoContainer.outerHeight(), 'videoContainer.outerWidth()', videoContainer.outerWidth());
      if(this.debug) console.log('videoBgEnlarge resize videoAspect', videoAspect, 'windowAspect', windowAspect);
      if (windowAspect > videoAspect) {
        if(this.debug) console.log('videoBgEnlarge resize windowAspect > videoAspect --> ', (windowAspect / videoAspect) * 100 + '%');
        // $videoBgWidth.width((windowAspect / videoAspect) * 100 + '%');
        // $videoBgWidth.css('width', (windowAspect / videoAspect) * 100 + '%');
        $videoBgWidth.get(0).style.width = (windowAspect / videoAspect) * 100 + '%';
      } else {
        if(this.debug) console.log('videoBgEnlarge resize windowAspect < videoAspect -->  ', (videoAspect / windowAspect) * 100 + '%');
        // $videoBgWidth.width(100 + "%")
        // $videoBgWidth.css('width', 100 + "%");
        $videoBgWidth.get(0).style.width = 100 + '%';
        // $videoBgWidth.width((videoAspect / windowAspect) * 100 + '%');
      }

    }
  }

}

export { VideoImageFullscreen };
